import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'ai-tool', {
    searchGoogleBooks: 'Search Google Books',
    searchGoogleBooksReasoning: 'Searching Google Books',
    searchGoogleBooksOutput: 'Found {{count}} Google Books results',
    searchGoogleBooksNoop: 'No Google Books results found',
    searchGoogleBooksError: 'Error searching Google Books',
    getGoogleBookById: 'Get Google Books volume by ID',
    getGoogleBookByIdReasoning: 'Fetching Google Books volume by ID',
    getGoogleBookByIdOutput: 'Fetched Google Books volume',
    getGoogleBookByIdNoop: 'Google Books volume not found',
    getGoogleBookByIdError: 'Error fetching Google Books volume',
    getGoogleBookByIsbn: 'Lookup Google Books by ISBN',
    getGoogleBookByIsbnReasoning: 'Looking up Google Books by ISBN',
    getGoogleBookByIsbnOutput: 'Found Google Books volume(s) by ISBN',
    getGoogleBookByIsbnNoop: 'No Google Books volume found for ISBN',
    getGoogleBookByIsbnError: 'Error looking up Google Books by ISBN',
  });
}
